// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caixa_visualizarLivro {
  height: 100%;
  margin: 1.9em;
}

.caixa_btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.caixa_btn > button {
  font-size: 1.5em;
  cursor: pointer;
  border: none;
  background-color: transparent;
}

.caixa_btn > button img {
  margin-right: 0.5em;
}

.btn_modais {
  width: 30%;
  display: flex;
  justify-content: space-between;
}

.btn_modais button {
  width: 45%;
  height: 2.4em;
  font-size: 1.2em;
  border: none;
  border-radius: 0.5em;
  color: var(--cor-branco);
  background-color: var(--cor-roxoEscuro);
  cursor: pointer;
}

.btn_editar {
  color: var(--cor-roxoEscuro) !important;
  background-color: var(--cor-roxoClaro) !important;
  border: 2px solid var(--cor-roxoEscuro) !important;
}

.caixa_infoLivros {
  height: 27%;
  margin-top: 2em;
  display: flex;
  justify-content: space-between;
}

.caixa_infoLivros > div {
  background-color: var(--cor-roxoInput);
  border-radius: 0.5em;
}

.dados_livro {
  width: 63%;
  min-height: 29vh;
  display: flex;
  justify-content: space-around;
}

.coluna1,
.coluna2,
.coluna3 {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.coluna1 > div,
.coluna2 > div,
.coluna3 > div {
  margin: 0.5em;
}

.caixa_sinopse {
  width: 35%;
  overflow-y: auto;
}

.caixa_sinopse h4 {
  position: sticky;
  top: 0;
  background: var(--cor-roxoInput);
  padding: 0.5em;
  font-weight: bold;
}

.caixa_sinopse > p {
  margin: 0.5em;
  text-align: justify;
}

.tabela_alunos_emprestimo {
  height: 50%;
  margin-top: 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/paginas/funcionario/VisualizacaoLivros.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".caixa_visualizarLivro {\n  height: 100%;\n  margin: 1.9em;\n}\n\n.caixa_btn {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.caixa_btn > button {\n  font-size: 1.5em;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n\n.caixa_btn > button img {\n  margin-right: 0.5em;\n}\n\n.btn_modais {\n  width: 30%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.btn_modais button {\n  width: 45%;\n  height: 2.4em;\n  font-size: 1.2em;\n  border: none;\n  border-radius: 0.5em;\n  color: var(--cor-branco);\n  background-color: var(--cor-roxoEscuro);\n  cursor: pointer;\n}\n\n.btn_editar {\n  color: var(--cor-roxoEscuro) !important;\n  background-color: var(--cor-roxoClaro) !important;\n  border: 2px solid var(--cor-roxoEscuro) !important;\n}\n\n.caixa_infoLivros {\n  height: 27%;\n  margin-top: 2em;\n  display: flex;\n  justify-content: space-between;\n}\n\n.caixa_infoLivros > div {\n  background-color: var(--cor-roxoInput);\n  border-radius: 0.5em;\n}\n\n.dados_livro {\n  width: 63%;\n  min-height: 29vh;\n  display: flex;\n  justify-content: space-around;\n}\n\n.coluna1,\n.coluna2,\n.coluna3 {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n}\n\n.coluna1 > div,\n.coluna2 > div,\n.coluna3 > div {\n  margin: 0.5em;\n}\n\n.caixa_sinopse {\n  width: 35%;\n  overflow-y: auto;\n}\n\n.caixa_sinopse h4 {\n  position: sticky;\n  top: 0;\n  background: var(--cor-roxoInput);\n  padding: 0.5em;\n  font-weight: bold;\n}\n\n.caixa_sinopse > p {\n  margin: 0.5em;\n  text-align: justify;\n}\n\n.tabela_alunos_emprestimo {\n  height: 50%;\n  margin-top: 2em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
